import React from "react";
import { paidTaskTableStyle } from "./paidTaskTableStyle";
import {
  getCaseLinkByBackofficeCase,
  getProductData,
  getProductNameBy,
} from "../../../services/Product/ProductService/productService";
import { Button, TableCell } from "@mui/material";
import { translate } from "../../../services/Translations/translatorService";
import { Link } from "react-router-dom";
import { convertFromFloat } from "../../../services/formServiceFunctions";
import { PaidTask } from "../../../types/PaidTask";
import Typography from "@mui/material/Typography";
import dayjs from "dayjs";

interface PaidTaskTableRowProps {
  paidTask: PaidTask;
}

const PaidTaskTableRow = ({ paidTask, ...props }: PaidTaskTableRowProps) => {
  const productClassName = getProductNameBy("lbProductClass", paidTask.backofficeCase.lbProductClass);

  return (
    <>
      <TableCell>
        <Typography sx={paidTaskTableStyle.link}>
          <Link to={getCaseLinkByBackofficeCase(paidTask.backofficeCase)}>
            {paidTask.backofficeCase.label || paidTask.backofficeCase.lbProductId}
          </Link>
        </Typography>
      </TableCell>
      <TableCell>{getProductData(productClassName, "generalLabel")}</TableCell>
      <TableCell>{paidTask.subject}</TableCell>
      <TableCell>{convertFromFloat(paidTask.fee)} €</TableCell>
      <TableCell>{translate("paidTask.status." + paidTask.status)}</TableCell>
      <TableCell>{paidTask.requestedUser ? paidTask.requestedUser.person.fullname : "-"}</TableCell>
      <TableCell>{paidTask.assignee ? paidTask.assignee.person.fullname : "-"}</TableCell>
      <TableCell>{dayjs(paidTask.assignmentDeadline).format("DD.MM.YYYY")}</TableCell>
      <TableCell>{dayjs(paidTask.doneDeadline).format("DD.MM.YYYY")}</TableCell>
      <TableCell>
        <Button
          component={Link}
          sx={paidTaskTableStyle.link}
          to={getCaseLinkByBackofficeCase(paidTask.backofficeCase) + "/ausschreibung/" + paidTask.id}
        >
          Details
        </Button>
      </TableCell>
    </>
  );
};
export default PaidTaskTableRow;
